import { useFormikContext } from 'formik'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { FORM_FIELDS, SCHEDULE_TYPES } from './fieldset'

function ScheduleReviewSection() {
  const { values } = useFormikContext()

  if (values[FORM_FIELDS.SCHEDULE_TYPE] !== SCHEDULE_TYPES.SCHEDULE) {
    return null
  }

  return (
    <>
      <div className="text-strong">
        <FormattedMessage id="GENERAL.SCHEDULE" />
      </div>
      <ul>
        <li>
          <FormattedMessage id="GENERAL.DATE" />: &nbsp;
          {new Date(values[FORM_FIELDS.SCHEDULED_DATE]).toLocaleString()}
        </li>

        {values[FORM_FIELDS.ALERT_ON_SUCCESS] && (
          <li>
            <FormattedMessage id="ENGAGE.SCHEDULING.ALERT_ON_SUCCESS" />
          </li>
        )}

        {values[FORM_FIELDS.ALERT_ON_FAILURE] && (
          <li>
            <FormattedMessage id="ENGAGE.SCHEDULING.ALERT_ON_FAILURE" />
          </li>
        )}
      </ul>
    </>
  )
}

export default ScheduleReviewSection
